export function isRecordingNow(d: any, now: number) {
  return d.recording && d.online && now - d.updatedAt < 60000
    && now - (d.recordingUpdatedAt ?? d.updatedAt) < 60000;
}
/** Consume each recording activation once, independently of stream permission. */
export function newActivations(devices: any[], seen: Set<string>, now: number) {
  return devices.filter(d => isRecordingNow(d, now))
    .sort((a, b) => (a.lastActivationAt || a.updatedAt) - (b.lastActivationAt || b.updatedAt))
    .filter(d => {
      const key = `${d.deviceId}:${d.lastActivationAt || 'initial'}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}
